import React, { useEffect, useRef } from 'react';
import { Formik, Field } from 'formik';

import * as Yup from 'yup';
import { InputField } from '../../../components/formFields/InputField';
import { getFieldErrors } from '../../../utils/apiError';

const ValidationSchema = Yup.object().shape({
  email: Yup.string().email('Zadejte validní e-mail!'),
});

const ProfileForm = ({
  formProps = {} as any,
  submitOutside = false as any,
  submit = () => {},
  error,
  reset = false,
  resetConfirm,
}: any) => {
  const formRef = useRef<any>();

  useEffect(() => {
    if (reset === true) {
      formRef.current?.setValues(init(formProps));
      resetConfirm?.();
    }
  }, [reset]);

  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed && submitOutside) {
      formRef.current?.submitForm();
    }

    return () => {
      isSubscribed = false;
    };
  }, [submitOutside]);

  useEffect(() => {
    formRef.current?.setErrors(getFieldErrors(error));
  }, [error]);

  const init = ({ degree_before, first_name, last_name, username, degree_after, email }: any) => {
    return {
      degree_before,
      first_name,
      last_name,
      username,
      degree_after,
      email,
    };
  };

  return (
    <div>
      <Formik
        validationSchema={ValidationSchema}
        innerRef={formRef}
        enableReinitialize={true}
        initialValues={init(formProps)}
        onSubmit={(values) => {
          submit(values);
        }}
      >
        {(props) => {
          const { values } = props;

          return (
            <form className="flex gap-2 flex-col">
              <Field
                name="username"
                value={values.username}
                placeholder="Uživatelské jméno"
                disabled
                component={InputField}
                data-testid="profile-form-username-input"
              />
              <Field
                name="email"
                value={values.email}
                placeholder="E-mail"
                disabled
                component={InputField}
                data-testid="profile-form-email-input"
              />
              <Field
                name="degree_before"
                value={values.degree_before}
                placeholder="Titul před jménem"
                component={InputField}
                data-testid="profile-form-degree-before-input"
              />
              <Field
                name="first_name"
                value={values.first_name}
                placeholder="Křestní jméno"
                component={InputField}
                data-testid="profile-form-first-name-input"
              />
              <Field
                name="last_name"
                value={values.last_name}
                placeholder="Příjmení"
                component={InputField}
                data-testid="profile-form-last-name-input"
              />
              <Field
                name="degree_after"
                value={values.degree_after}
                placeholder="Titul za jménem"
                component={InputField}
                data-testid="profile-form-degree-after-input"
              />
            </form>
          );
        }}
      </Formik>
    </div>
  );
};

export default ProfileForm;
